import { createContext} from 'react';
import { NotificationData } from '../libs/Notification';

export const NotificationContext = createContext<{
  notifications: NotificationData[];
  addNotification: (data: NotificationData) => void;
  removeNotification: (index: number) => void;
}>({
  notifications: [],
  addNotification: () => {},
  removeNotification: () => {},
});
